import { put } from 'redux-saga/effects';
import { createHiringVehicle, createHiringProponent, createHiringMainDriver } from 'store/auto/store/ducks/automovel';

export default function* createHiringPayloadAction({ data: { proponente } }) {
  yield put(createHiringProponent(proponente));
  yield put(createHiringMainDriver({}));
  yield put(createHiringVehicle({}));
}
